@if (contentReady() == 'input') {
  <div
    class="flex h-full w-full flex-col content-center items-center space-y-4"
  >
    @if (!twoFactorType()) {
      <span class="w-full pb-4 text-center text-3xl font-semibold text-white">{{
        "Accedi con l\'email" | siaTranslate
      }}</span>
      <form
        [formGroup]="loginForm"
        class="flex w-full flex-col items-center justify-center space-y-4"
        (ngSubmit)="login()"
      >
        <mat-form-field class="sia-login w-full" appearance="outline">
          <mat-label>{{ 'Email' | siaTranslate }}</mat-label>
          <input
            matInput
            id="userIdentifier"
            formControlName="userIdentifier"
            autocomplete="email"
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            type="text"
            [disabled]="loginStarted()"
          />
        </mat-form-field>
        <button
          mat-flat-button
          class="secondary w-full"
          type="submit"
          [disabled]="loginStarted()"
        >
          @if (loginStarted()) {
            <i class="fa fa-spinner fa-spin"></i>
          }
          {{ 'Accedi' | siaTranslate }}
        </button>
      </form>
    } @else {
      <span class="w-full pb-4 text-center text-3xl font-semibold text-white">{{
        'Inserire il pin temporaneo' | siaTranslate
      }}</span>
      <form id="otpForm" (ngSubmit)="login()" class="w-full">
        <mat-form-field class="sia-login w-full" appearance="outline">
          <mat-label>{{ 'Codice OTP' | siaTranslate }}</mat-label>
          <input
            matInput
            [ngModel]="otp()"
            name="otp"
            type="text"
            autocomplete="one-time-code"
            (ngModelChange)="onOtpChange($event)"
          />
        </mat-form-field>
        <button
          mat-flat-button
          [disabled]="isOtpInvalid() || loginStarted()"
          class="secondary w-full"
          type="submit"
        >
          @if (loginStarted()) {
            <i class="fa fa-spinner fa-spin"></i>
          }
          {{ 'Accedi' | siaTranslate }}
        </button>
      </form>
      <div class="mt-2 flex w-full flex-col items-center gap-2 md:flex-row">
        @if (twoFactorType() == 'email') {
          <p
            class="w-full text-center text-sm"
            (click)="buttonDisable() ? null : sendNewPin()"
            [style.opacity]="buttonDisable() ? 0.5 : 1"
            [class.cursor-not-allowed]="buttonDisable()"
            [class.cursor-pointer]="!buttonDisable()"
          >
            {{ 'Richiedi codice in ' | siaTranslate }} {{ minutes() }}:{{
              seconds2Digits()
            }}
          </p>
        }
        <button
          mat-button
          class="flex-grow"
          [style]="{ color: 'white !important' }"
          (click)="reset2FALogin()"
        >
          {{ 'Cambia utente' | siaTranslate }}
        </button>
      </div>
    }
  </div>
}
@if (contentReady() == 'auto') {
  <div class="flex flex-col items-center justify-center space-y-4">
    <mat-spinner></mat-spinner>
    <span class="text-center text-2xl">{{
      'Ti stiamo connettendo al portale' | siaTranslate
    }}</span>
  </div>
}
